import { Injectable }     from '@angular/core';
import {NavigationEnd} from '@angular/router';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

import {SecretService} from './secret';

declare let window: any;

export const METHODS = ['GET', 'PUT', 'POST', 'PATCH', 'HEAD', 'OPTIONS', 'DELETE'];
const METHOD_AND_PATH_REGEX = /^(GET|PUT|POST|PATCH|HEAD|OPTIONS|DELETE)\s+(\/.*)$/i;

const shiftLines = (code, numSpaces) => {
  if (!numSpaces) return code;
  var lines = code.split('\n');
  var spaces = Array(numSpaces + 1).join(' ');
  return lines.map(function(l, idx) {return (l && idx > 0) ? spaces + l : l}).join('\n');
}

@Injectable()
export class UtilsService {
  lucybot:any = window.lucybot;
  config:any = window.config;
  markdownToRecipe:Function = require('../../lib/markdown-to-recipe.js');
  recipeToMarkdown:Function = require('../../lib/recipe-to-markdown.js');

  constructor(private sanitizer:DomSanitizer,
              private secrets:SecretService) {
    window.utilsService = this;
    window.NavigationEnd = NavigationEnd;
  }

  markUpOperationTitle(title) {
    let m = title.match(METHOD_AND_PATH_REGEX);
    if (!m) return title;
    let method = m[1];
    let path = m[2];
    let markedUp = `<span data-method="${method.toLowerCase()}">${method.toUpperCase()}</span><span class="operation-path">${path}</span>`;
    return this.sanitizer.bypassSecurityTrustHtml(markedUp);
  }

  getTemplateInput(input:any={}) {
    input = Object.assign({
      shift: shiftLines,
      answers: {},
    }, input);
    for (let key in this.secrets.secrets) {
      if (input.answers[key] === undefined) input.answers[key] = this.secrets.secrets[key];
    }
    return input;
  }
  render(template, input:any={}) {
    input = this.getTemplateInput(input);
    try {
      return window.ejs.render(template, input);
    } catch (e) {
      return e;
    }
  }

  scrollToSelection(sel, ignoreNav=false, putElementAtTop=false) {
    const OFFSET = 10;
    let navHeight = window.jQuery('nav').height();
    let visibleHeight = window.innerHeight - navHeight;
    let targetTop = sel.offset().top - (ignoreNav ? 0 : navHeight); // puts elem at top of visible area
    let curScrollTop = window.jQuery('body').scrollTop();
    let movement = curScrollTop - targetTop;
    if (Math.abs(movement) > (window.innerHeight / 2)) {  // if elem already in top-half of screen, do nothing
      let diffFromWindow = visibleHeight - sel.height();
      if (diffFromWindow > 0 && !putElementAtTop) {
        targetTop -= diffFromWindow - OFFSET;  // Only scroll far enough to make entire elem visible
      } else {
        targetTop -= OFFSET;
      }
      window.jQuery('html,body').animate({
          scrollTop: targetTop,
      }, 1000);
    }
  }

  followPath(obj, path) {
    if (!path || !obj) return obj;
    var dot = path.indexOf('.');
    if (dot === -1) return obj[path];
    var key = path.substring(0, dot);
    return this.followPath(obj[key], path.substring(dot + 1))
  }

}



// WEBPACK FOOTER //
// ./src/app/services/utils.ts